import React, { useEffect, useState } from 'react';
import { isNil, some } from 'lodash';
import { useQuery } from 'react-query';
import { useParams, useHistory } from 'react-router-dom';
import { Col, Form, notification, Row, Tabs, Switch, Input } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import TextArea from 'antd/lib/input/TextArea';
import { ArrowLeftOutlined } from '@ant-design/icons';
import SaveButton from 'components/SaveButtonTabsTop';
import DF from 'DisplayFramework';
import ParcodeParentListSelect from '../../Components/ParametersListSelect';
import ParameterValuesTable from './ParameterValuesTable';
import {
  createParameter,
  getParameterDetail,
  updateParameter,
} from 'services/parametersService';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { NormalizeOnlyAlph } from 'utils/utils2';

const { TabPane } = Tabs;
type ParameterDetailProps = {
  parcode: string;
};
const ParameterDetail = ({ parcode: parcodeprop }: ParameterDetailProps) => {
  const { idOrCreate } = useParams<{ idOrCreate: string }>();
  const isCreate = idOrCreate === 'create';

  const id = !isCreate
    ? isNil(parcodeprop)
      ? idOrCreate
      : parcodeprop
    : undefined;
  const [Activekey, setActiveKey] = useState('1');

  const { data: values, refetch } = useQuery<object>(
    `getParameterDetail/${id}`,
    () => getParameterDetail({ parcode: id! }).then((res: any) => res.data),
    {
      enabled: !!id,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    setActiveKey('1');
  }, [id]);

  const [form] = useForm();
  const history = useHistory();

  useEffect(() => {
    if (values) {
      form.setFieldsValue(values);
    }
    refetch();
  }, [form, values, refetch]);

  const submit = () => {
    const requestPaylod = {
      parLists: form.getFieldValue('parLists'),
      parcode: form.getFieldValue('parcode'),
      parcodeparent: form.getFieldValue('parcodeparent'),
      parcodeparentlabel: form.getFieldValue('parcodeparentlabel'),
      pardescription: form.getFieldValue('pardescription'),
      parlabel: form.getFieldValue('parlabel'),
      parmodule: form.getFieldValue('parmodule'),
      parmodulelabel: form.getFieldValue('parmodulelabel'),
      paroperator: form.getFieldValue('paroperator'),
      partype: form.getFieldValue('partype'),
      partypelabel: form.getFieldValue('partypelabel'),
      parvaluemax: form.getFieldValue('parvaluemax'),
      parvaluemin: form.getFieldValue('parvaluemin'),
      flagofferfilter: form.getFieldValue('flagofferfilter'),
      flagproductfilter: form.getFieldValue('flagproductfilter'),
      flaguserfilter: form.getFieldValue('flaguserfilter'),
      flagsystem: form.getFieldValue('flagsystem'),
      flagworkflow: form.getFieldValue('flagworkflow'),
      parvalueexternal:form.getFieldValue('parvalueexternal')
    };

    if (isCreate) {
      return createParameter({ parameterRequest: requestPaylod }).then(
        (response) => {
          if (response.code==='200') {
          notification.success({
            message: 'The parameter has been successfully created',
          });
          history.push(
            `/configuration/management/parameters/${response.data.parcode}`
          );
        
          } else {
            notification.error({
              message: response.message,
            });
  
          }
        }
      );
    } else {
      return updateParameter({
        parcode: id!,
        parameterRequest: requestPaylod,
      }).then(() =>
        notification.success({
          message: 'The parameter has been successfully updated',
        })
      );
    }
  };

  const initialValues = {
    parLists: [],
    parcode: '',
    parcodeparent: '',
    parcodeparentlabel: '',
    pardescription: '',
    parlabel: '',
    parmodule: '',
    parmodulelabel: '',
    paroperator: '',
    partype: '',
    partypelabel: '',
    parvaluemax: '',
    parvaluemin: '',
    flaguserfilter: false,
    flagproductfilter: false,
    flagofferfilter: false,
    flagsystem: false,
    flagworkflow: false,
    parvalueexternal:''
  };

  return (
    <DF.Provider pagcode="paramdetail">
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={submit}
        initialValues={initialValues}
        labelAlign="left"
      >
        <div className="card-container">
          <Tabs
            defaultActiveKey="1"
            type="card"
            tabBarExtraContent={
              <SaveButton
                comcode={isCreate ? 'save' : 'update'}
                disabled={!(Activekey === '1')}
              />
            }
            activeKey={Activekey}
            onChange={(e) => {
              setActiveKey(e);
            }}
          >
            <TabPane
              tab={
                <>
                  <ArrowLeftOutlined
                    onClick={() => {
                      history.push(`/configuration/management/parameters`);
                    }}
                  />
                  <GetLabel label="parameterDetail" />
                </>
              }
              key="1"
            >
              <Row
                style={{
                  marginTop: '45px',
                  marginBottom: '10px',
                  padding: '20px',
                }}
                gutter={40}
              >
                <Col xs={24} lg={12}>
                  <Row gutter={30} style={{ textAlign: 'left' }}>
                    <Col style={{ marginBottom: '30px' }} lg={12} xs={12}>
                      <FormInput
                        name="parcode"
                        labelAlign="left"
                        normalize={NormalizeOnlyAlph}
                        rules={[
                          {
                            required: true,
                            message: 'Max 10 characters',
                            max: 10,
                          },
                        ]}
                      >
                        <Input disabled={!isCreate} />
                      </FormInput>
                    </Col>

                    <Col style={{ marginBottom: '30px' }} lg={12} xs={12}>
                      <FormInput name="parlabel" labelAlign="left" />
                    </Col>
                    <Col style={{ marginBottom: '30px' }} lg={12} xs={12}>
                      <FormInput name="parmodule" labelAlign="left">
                        <ParListSelect parcode="MODULE" disabled={!isCreate} />
                      </FormInput>
                    </Col>
                    <Col style={{ marginBottom: '30px' }} lg={12} xs={12}>
                      <FormInput name="partype" labelAlign="left">
                        <ParListSelect parcode="PARTYPE" disabled={!isCreate} />
                      </FormInput>
                    </Col>
                    <Col style={{ marginBottom: '30px' }} lg={12} xs={12}>
                      <FormInput name="paroperator" labelAlign="left">
                        <ParListSelect parcode="PAROPER" disabled={!isCreate} />
                      </FormInput>
                    </Col>
                    <Col style={{ marginBottom: '30px' }} lg={12} xs={12}>
                      {/* <DF.Input
                        name="parcodeparent"
                        component={ParcodeParentListSelect}
                        componentProps={{
                          parcode: form.getFieldValue('parcode') ?? '',
                          parlabel: form.getFieldValue('parlabel') ?? '',
                          disabled: !isCreate,
                          showSearch: true,
                        }}
                      /> */}
                      <FormInput name="parcodeparent">
                        <ParcodeParentListSelect
                          // parcode={form.getFieldValue('parcode')}
                          // parlabel={form.getFieldValue('parlabel')}
                          disabled={!isCreate}
                          showSearch
                        />
                      </FormInput>
                    </Col>
                    <Col style={{ marginBottom: '30px' }} lg={12} xs={12}>
                      <Form.Item
                        noStyle
                        shouldUpdate={(prevValue, curValue) =>
                          prevValue.paroperator !== curValue.paroperator
                        }
                      >
                        {({ getFieldValue }) =>
                          getFieldValue('paroperator') !== 'IN' && (
                            <DF.Input name="parvaluemin" />
                          )
                        }
                      </Form.Item>
                    </Col>
                    <Col style={{ marginBottom: '30px' }} lg={12} xs={12}>
                      <Form.Item
                        noStyle
                        shouldUpdate={(prevValue, curValue) =>
                          prevValue.paroperator !== curValue.paroperator
                        }
                      >
                        {({ getFieldValue }) =>
                          getFieldValue('paroperator') === 'BETWEEN' && (
                            <DF.Input name="parvaluemax" />
                          )
                        }
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col xs={24} lg={12}>
                  <Row gutter={30}>
                    <FormInput
                      col
                      xs={12}
                      lg={10}
                      name="flagproductfilter"
                      valuePropName="checked"
                      wrapperCol={{ span: 13 }}
                      labelCol={{ span: 11 }}
                      labelAlign="left"
                    >
                      <Switch />
                    </FormInput>
                    <FormInput
                      col
                      xs={12}
                      lg={10}
                      name="flagofferfilter"
                      valuePropName="checked"
                      wrapperCol={{ span: 13 }}
                      labelCol={{ span: 11 }}
                      labelAlign="left"
                    >
                      <Switch />
                    </FormInput>
                    <FormInput
                      col
                      xs={12}
                      lg={10}
                      name="flaguserfilter"
                      valuePropName="checked"
                      wrapperCol={{ span: 13 }}
                      labelCol={{ span: 11 }}
                      labelAlign="left"
                    >
                      <Switch />
                    </FormInput>
                    <FormInput
                      col
                      xs={12}
                      lg={10}
                      name="flagsystem"
                      valuePropName="checked"
                      wrapperCol={{ span: 13 }}
                      labelCol={{ span: 11 }}
                      labelAlign="left"
                    >
                      <Switch />
                    </FormInput>
                  </Row>
                  <Row gutter={30}>
                    <FormInput
                      col
                      xs={12}
                      lg={10}
                      name="flagworkflow"
                      valuePropName="checked"
                      wrapperCol={{ span: 13 }}
                      labelCol={{ span: 11 }}
                      labelAlign="left"
                    >
                      <Switch />
                    </FormInput>
                  </Row>
                  <FormInput
                    wrapperCol={{ span: 24 }}
                    labelCol={{ span: 24 }}
                    labelAlign="left"
                    name="pardescription"
                  >
                    <TextArea />
                  </FormInput>
                </Col>
              </Row>

              <Row gutter={16}></Row>
            </TabPane>

            <TabPane
              disabled={isCreate}
              tab={<GetLabel label="ParameterValuesTable" />}
              key="2"
            >
              {isCreate ? null : (
                <Row gutter={16}>
                  <Col xs={24}>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValue, curValue) =>
                        prevValue.parLists.length !==
                          curValue.parLists.length ||
                        (some(prevValue.parLists, 'isNew') &&
                          !some(curValue.parLists, 'isNew')) ||
                        (prevValue.paroperator === '' &&
                          curValue.paroperator === 'IN')
                      }
                    >
                      {({ getFieldValue }) =>
                        getFieldValue('paroperator') === 'IN' && (
                          <ParameterValuesTable
                            form={form}
                            ParcodeParent={form.getFieldValue('parcodeparent')}
                            refetch={() => refetch()}
                            flagworkflow={form.getFieldValue('flagworkflow')}
                          />
                        )
                      }
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </TabPane>
          </Tabs>
        </div>
      </Form>
    </DF.Provider>
  );
};

export default ParameterDetail;
